module.exports = __webpack_public_path__ + "static/media/16-hjerne.7cd7eeea.mp3";